import React from "react";
import Slider from "react-slick";

const clientLogos = [
  { img: "/logos/1.png", alt: "namahSoftech" },
  { img: "/logos/2.png", alt: "The Tech Galore" },
  { img: "/logos/3.png", alt: "ProcessQ" },
  { img: "/logos/4.png", alt: "Taranga party boss" },
  { img: "/logos/5.png", alt: "newU Clinic" },
  { img: "/logos/6.png", alt: "RSCC" },
  { img: "/logos/14.png", alt: "Setspace" },
  { img: "/logos/7.png", alt: "Taranga" },
  { img: "/logos/8.png", alt: "Taika Martial Arts Academy" },
  { img: "/logos/9.png", alt: "Trident" },
  { img: "/logos/10.png", alt: "incor" },
  { img: "/logos/11.png", alt: "Crushed Cardamom" },
  { img: "/logos/12.png", alt: "Mandi Bistro" },
  { img: "/logos/13.png", alt: "Dharani" },
];

const GrowthPartner = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4, // Desktop default
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 1500,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1280, // Laptop
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024, // Large tablets and small laptops
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // Tablets
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // Mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="max-w-7xl mx-auto px-6 py-12 text-center">
      {/* Heading */}
      <h2 className="text-3xl md:text-5xl font-bold text-black relative inline-block">
        Our{" "}
        <span className="relative z-10">
          <span className="underline decoration-blue-500 decoration-4">
            Clients
          </span>{" "}
        </span>
      </h2>

      {/* Subheading */}
      <p className="text-gray-600 mt-4 max-w-2xl text-xl mx-auto">
        Our team of experts is passionate about helping businesses of all sizes
        establish a strong online presence and achieve sustainable growth.
      </p>

      {/* Logos Slider */}
      <div className="py-4">
        <Slider {...settings}>
          {clientLogos.map((client, index) => (
            <div key={index} className="px-1 md:px-2">
              <img
                src={client.img}
                alt={client.alt}
                className="h-32 sm:h-32 md:h-40 lg:h-48 mx-auto object-contain"
              />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default GrowthPartner;
